import { Box, Button, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import React, { useState, useEffect } from 'react';
import SubCard from 'ui-component/cards/SubCard';
import { GetFieldData, ProvideApproval } from 'API/Approval/api';
import { getConfigDataProductID } from 'API/Config/api';

import RequestPagination from './Components/Pagination';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { IoClose } from "react-icons/io5";
import MappingDialog from './MappingComponents/PendingModal';
import ApprovePage from './MappingComponents/ApprovePage';


function PendingForm(props) {
  const [data, setData] = useState(null);
  const [value, setValue] = useState(null);
  const [Selected, setSelected] = useState(null);
  const [selectedProducts, setSelectedProducts] = useState(null);
  const [PostData, setPostData] = useState(null);
  const userType = sessionStorage.getItem('UserType');
  const user_id = sessionStorage.getItem('user_id');

  const [ProductsSelected, setProductsSelected] = useState(null);
  const [DummyData, setDummyData] = useState(null);
  const rowsPerPage = 10;
  const [Page, setPage] = useState(1);
  const [TotalCount, setTotalCount] = useState(0);
  const [currentItems, setCurrentItems] = useState(null);
  const [ViewSelected, setViewSelected] = useState(false)

  function formatDate(dateString) {
    const date = new Date(dateString);

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const formattedDate = `${day}-${month}-${year}`;

    return `${formattedDate}`;
  }

  function formatTime(dateString) {
    const date = new Date(dateString);
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    const formattedHours = hours.toString().padStart(2, '0');
    const formattedTime = `${formattedHours}:${minutes}:${seconds} ${ampm}`;
    return `${formattedTime}`;
  }




  useEffect(() => {
    setData(props.data)
  }, [props.data])




  const handleCspClose = () => {
    setOpenCsp(false);
  };

  const handleAlertOpen = () => {
    setAlertOpen(true);
  };


  const smStyles = {
    width: '100%',
    display: 'flex',
    gap: '30px',
    flexDirection: 'column'
  };

  const mdLgXlStyles = {
    width: '100%',
    display: 'flex',
    gap: '30px',
    flexDirection: 'row'
  };

  const handleSelect = () => {
    setSelected(value);
  };

  const handleItemClick = (index) => {
    setValue(FilteredData[index]);
  };

  const handleRequestView = (data) => {
    setSelectedProducts(data);
    setViewSelected(true)
    setValue(null)
  }

  const handleViewSelectedClose = () => {
    setViewSelected(false)
    setSelectedProducts(null)
  }

  const handleClose = () => {
    setSelected(null);
    setRows([]);
    setSelectedProducts(null);
    setValue(null);
    setPostData(null);
    handleCspClose();
  };

  console.log('id ', user_id);

  useEffect(() => {
    if (PostData !== null) {
      if (PostData.status === 'rejected') {
        if (PostData.rejected_reason) {
          ProvideApproval(PostData, setData, handleClose, setAlertMessage, handleAlertOpen, setAlertType, setDisableButtons);
        } else {
          setAlertMessage('Fill reject reason');
          setAlertType('error');
          handleAlertOpen();
        }
      } else {
        if (userType === 'tm' || userType === 'rm' || userType === 'sh') {
          if (
            (BranchData.branch_code || UserData[0].branch_code) &&
            (BranchData.branch_name || UserData[0].branch_name) &&
            (BranchData.ro_name || UserData[0].ro_name || BranchData.circle_zo_name || UserData[0].circle_zo_name) &&
            (BranchData.locality_or_village || UserData[0].locality_or_village || BranchData.lho || UserData[0].lho) &&
            (!BranchData.csp_type || BranchData.csp_type === 'new' || (BranchData.csp_type !== 'new' && BranchData.csp_code))
          ) {
            ProvideApproval(PostData, setData, handleClose, setAlertMessage, handleAlertOpen, setAlertType, setDisableButtons);
          } else {
            setAlertMessage('Fill branch details');
            setAlertType('error');
            handleAlertOpen();
          }
        } else {
          ProvideApproval(PostData, setData, handleClose, setAlertMessage, handleAlertOpen, setAlertType, setDisableButtons);
        }
      }
    }
  }, [PostData]);



  useEffect(() => {
    if (Selected) {
      GetFieldData(setPincode, ['retail_pincode'], Selected.user_id);
    }
  }, [Selected]);




  const handlePopupClose = () => {
    setValue(null)
    setSelectedProducts(null)
  }

  const [FilteredData, setFilteredData] = useState(null);

  useEffect(() => {
    if (data&&Array.isArray(data.data)) {
      let filter = data.data.filter((item) => {
        return (sessionStorage.getItem('UserType')==='sh'&&!item.sh_approved && item.status === 'pending')||(sessionStorage.getItem('UserType')==='rm'&&item.sh_approved && item.status === 'pending')||(sessionStorage.getItem("UserType")==="cso"&&item.status === 'pending')
      });
      setFilteredData(filter);

    }
  }, [data, props.filterData]);




  useEffect(() => {
    if (Selected && userType === 'ops') {
      getConfigDataProductID(Selected.product_id, setProductsSelected);
    }
  }, [Selected]);

  useEffect(() => {
    if (FilteredData) {
      let divisions = Math.ceil(FilteredData.length / rowsPerPage);
      setTotalCount(divisions);
    }
  }, [FilteredData]);

  useEffect(() => {
    if (ProductsSelected) {
      let filter = ProductsSelected.categories
        .map((filtered) => {
          return filtered.fields
            .map((field) => {
              if (field.field_type === 'Documents' && field.required) {
                return field.field_name;
              }
              return undefined;
            })
            .filter((fieldName) => fieldName !== undefined);
        })
        .flat();

      setDummyData(filter);
    }
  }, [ProductsSelected]);

  useEffect(() => {
    if (DummyData) {
      GetFieldData(setRequiredDocuments, DummyData, Selected.user_id);
    }
  }, [DummyData]);


  useEffect(() => {
    if (FilteredData) {
      const indexOfLastItem = Page * rowsPerPage;
      const indexOfFirstItem = indexOfLastItem - rowsPerPage;
      const currentItems = FilteredData.slice(indexOfFirstItem, indexOfLastItem);
      setCurrentItems(currentItems);
    }
  }, [FilteredData, Page]);

  return ViewSelected ?
    <ApprovePage type="pending" userData={selectedProducts} handleClose={handleViewSelectedClose} />
    :
    FilteredData && FilteredData.length > 0 ? (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <MappingDialog open={value} handleClose={handlePopupClose} handleViewRequest={handleRequestView} />
        <div style={window.innerWidth >= 600 ? mdLgXlStyles : smStyles}>
          <div style={{ maxHeight: window.innerWidth >= 600 ? '100%' : '100%', overflowY: 'scroll', width: '100%', scrollbarWidth: 'none' }}>
            <Stack spacing={2} sx={{ width: '50%', maxHeight: '100%' }}>
              {FilteredData && currentItems && Array.isArray(currentItems) && currentItems.length > 0
                ? currentItems &&
                currentItems.map((item, index) => {
                  return (sessionStorage.getItem('UserType')==='sh'&&!item.sh_approved && item.status === 'pending')||(sessionStorage.getItem('UserType')==='rm'&&item.sh_approved && item.status === 'pending') ||(sessionStorage.getItem("UserType")==="cso"&&item.status === 'pending')? (
                    <SubCard
                      title={`${item.ds_details.username} - ${item.ds_details.usercode}`}
                      key={index}
                      sx={{ cursor: 'pointer' }}
                      onClick={() => handleItemClick(index)}
                    >
                      <Stack direction="column">
                        <table style={{ width: 'max-content' }}>
                        <tr>
                            <td>
                              {' '}
                              <Typography variant="subtitle1" color="grey">
                                Request
                              </Typography>
                            </td>
                            <td>:</td>
                            <td>
                              {' '}
                              <Typography variant="subtitle1" color="grey">
                                Csp Mapping Request
                              </Typography>
                              
                            </td>
                          </tr>
                          <tr>
                            <td>
                              {' '}
                              <Typography variant="subtitle1" color="grey">
                                No of csp
                              </Typography>
                            </td>
                            <td>:</td>
                            <td>
                              {' '}
                              <Typography variant="subtitle1" color="grey">
                                {item.no_of_person}
                              </Typography>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              {' '}
                              <Typography variant="subtitle1" color="grey">
                                Created Date
                              </Typography>
                            </td>
                            <td>:</td>
                            <td>
                              {' '}
                              <Typography variant="subtitle1" color="grey">
                                {formatDate(item.ds_requested_at) + "/" + formatTime(item.ds_requested_at)}
                              </Typography>
                            </td>
                          </tr>
                        </table>
                      </Stack>
                    </SubCard>
                  ) : userType === 'ops' &&
                    item.kiosk_tm_approved &&
                    item.status === 'pending' &&
                    item.product_availed &&
                    (item.flow === 1 || (item.flow === 2 && item.kyc_reupload === true)) ? (
                    <SubCard
                      title={`${item.agent_name} - ${item.agent_code}`}
                      key={index}
                      sx={{ cursor: 'pointer' }}
                      onClick={() => handleItemClick(index)}
                    >
                      <Stack direction="column">
                        <table style={{ width: 'max-content' }}>
                          <tr>
                            <td>
                              {' '}
                              <Typography variant="subtitle1" color="grey">
                                Product
                              </Typography>
                            </td>
                            <td>:</td>
                            <td>
                              {' '}
                              <Typography variant="subtitle1" color="grey">
                                {item.product_name}
                              </Typography>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              {' '}
                              <Typography variant="subtitle1" color="grey">
                                Created Date
                              </Typography>
                            </td>
                            <td>:</td>
                            <td>
                              {' '}
                              <Typography variant="subtitle1" color="grey">
                                {formatDate(item.kiosk_submission) + "/" + formatTime(item.kiosk_submission)}
                              </Typography>
                            </td>
                          </tr>
                        </table>
                      </Stack>
                    </SubCard>
                  ) : null;
                })
                : null}
            </Stack>
          </div>
          <React.Fragment>

            <Dialog open={value && value.user_id ? true : false} onClose={handleClose} fullWidth maxWidth="xs" aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
              <DialogContent>
                <Box sx={{ position: "absolute", top: 5, right: 5, fontSize: '25px', cursor: "pointer" }} onClick={handleClose}>
                  <IoClose />
                </Box>
                <DialogContentText id="alert-dialog-description">
                  <Stack sx={{ width: '100%', display: 'flex', visibility: value ? 'visible' : 'hidden' }}>
                    <Stack direction="column" justifyContent="center" alignItems="center">
                      <table style={{ width: '100%' }}>
                        <tr>
                          <td>
                            <Typography variant="subtitle1" color="grey">
                              Agent Name
                            </Typography>
                          </td>
                          <td>:</td>
                          <td>
                            <Typography variant="subtitle1" color="grey">
                              {selectedProducts && selectedProducts.agent_name ? selectedProducts.agent_name : ''}
                            </Typography>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <Typography variant="subtitle1" color="grey">
                              Agent Code
                            </Typography>
                          </td>
                          <td>:</td>
                          <td>
                            <Typography variant="subtitle1" color="grey">
                              {selectedProducts && selectedProducts.agent_code ? selectedProducts.agent_code : ''}
                            </Typography>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <Typography variant="subtitle1" color="grey">
                              Product
                            </Typography>
                          </td>
                          <td>:</td>
                          <td>
                            <Typography variant="subtitle1" color="grey">
                              {selectedProducts && selectedProducts.product_name ? selectedProducts.product_name : ''}
                            </Typography>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <Typography variant="subtitle1" color="grey">
                              Created date & Time
                            </Typography>
                          </td>
                          <td>:</td>
                          <td>
                            <Typography variant="subtitle1" color="grey">
                              {selectedProducts && selectedProducts.kiosk_submission
                                ? `${formatDate(selectedProducts.kiosk_submission)} / ${formatTime(selectedProducts.kiosk_submission)}`
                                : ''}
                            </Typography>
                          </td>
                        </tr>
                        {sessionStorage.getItem('UserType') === 'ops' ? (
                          <tr>
                            <td>
                              <Typography variant="subtitle1" color="grey">
                                  Updated date & Time
                              </Typography>
                            </td>
                            <td>:</td>
                            <td>
                              <Typography variant="subtitle1" color="grey">
                                {selectedProducts &&
                                  selectedProducts.kiosk_tm_approved_details &&
                                  selectedProducts.kiosk_tm_approved_details.approved_at
                                  ? `${formatDate(selectedProducts.kiosk_tm_approved_details.approved_at)} / ${formatTime(
                                    selectedProducts.kiosk_tm_approved_details.approved_at
                                  )}`
                                  : ''}
                              </Typography>
                            </td>
                          </tr>
                        ) : null}
                      </table>
                      <Button variant="contained" color='secondary' sx={{ mt: 2 }} onClick={handleSelect}>
                        View Request
                      </Button>
                    </Stack>
                  </Stack>
                </DialogContentText>
              </DialogContent>
            </Dialog>
          </React.Fragment>

        </div>
        <Stack justifyContent="flex-end" alignItems="flex-end" mt={2}>
          <RequestPagination page={Page} setPage={setPage} count={TotalCount} />
        </Stack>
      </div>
    ) : (
      
      <Stack justifyContent="center" alignItems="center">
        <Typography mt={1} variant="subtitle1" color="grey">
            No record found
        </Typography>
      </Stack>
    );
}

export default PendingForm;
